import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBoxObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationPostureElbowPosition extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Posture - Elbow Position' />
                    <label className={styles.label}>Elbow Position</label>
                    <span className={styles.sublabel} />
                    <label className={styles.col_1_header}>R</label>
                    <label className={styles.col_1_header}>L</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel} >Internal Rotation</label>
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSELBOWPOSINTROTR'
                        className={styles.lr_checkbox}
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSELBOWPOSINTROTL'
                        className={styles.lr_checkbox}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel} >External Rotation</label>
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSELBOWPOSEXTROTR'
                        className={styles.lr_checkbox}
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSELBOWPOSEXTROTL'
                        className={styles.lr_checkbox}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel} >Flexed</label>
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSELBOWPOSFLEXEDR'
                        className={styles.lr_checkbox}
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSELBOWPOSFLEXEDL'
                        className={styles.lr_checkbox}
                    />
                </div>
            </div >
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSELBOWPOSINTROTR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSELBOWPOSINTROTL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSELBOWPOSEXTROTR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSELBOWPOSEXTROTL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSELBOWPOSFLEXEDR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSELBOWPOSFLEXEDL
            ? true : false
    };
}

const connectedObservationPostureElbowPosition = connect(mapStateToProps)(ObservationPostureElbowPosition);
export { connectedObservationPostureElbowPosition as ObservationPostureElbowPosition };


